export default __webpack_public_path__ + "static/product-unit-10-life-ddcf9faa918fab5156db3b9f06bda711.png";